import React, { useEffect, useState } from 'react';
import * as yup from 'yup';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import CustomButton from '../../../../../common/components/buttons/CustomButton';
import { Box, Grid, Slide, TextField, Typography } from '@mui/material';
import CustomTextField from '../../../../../common/components/customized/customtextfield/CustomTextField';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { TransitionProps } from '@mui/material/transitions';
import { useAppDispatch, useAppSelector } from '../../../../../app/redux/hooks';
import { shareTripsAction } from '../../../redux/reducer/yaantracSlices/mytripsSlice';
import CustomRadioButton from '../../../../../common/components/customized/customradiobutton/CustomRadioButton';
import PhoneNoTextField from '../../../../../common/components/customized/customtextfield/PhoneNoTextField';
import './ShareTrip.scss';

interface ShareTrip {
  openShare: boolean;
  setOpenShare: React.Dispatch<React.SetStateAction<boolean>>;
  row: any;
}

interface TextField {
  id: string;
  label: string;
  defaultValue?: string;
  disabled?: boolean;
  field: 'email';
  placeholder: string;
  inputProps?: {
    maxLength?: number;
    style?: React.CSSProperties;
  };
  multiline?: boolean;
  maxRows?: number;
}

// for smooth transition dialog box
// const Transition = React.forwardRef(function Transition(
//   props: TransitionProps & {
//     children: React.ReactElement<any, any>;
//   },
//   ref: React.Ref<unknown>
// ) {
//   return <Slide direction='up' ref={ref} {...props} />;
// });

const ShareTrip = ({ openShare, setOpenShare, row }: ShareTrip) => {
  const [isEmail, setIsEmail] = useState<Boolean>(false);

  const { isLoading } = useAppSelector(state => state.shareTripSlice);

  const dispatch = useAppDispatch();

  const textfield: TextField[] = [
    {
      id: '1',
      label: 'Email ID',
      field: 'email',
      placeholder: 'Enter the Email Id'
    }
  ];

  // validation schema
  const schema = yup.object().shape({
    email: yup.string().email('Enter a valid Email Id').required('Email is required'),
    // phone: yup.string().optional()
    phone: yup.string().notRequired()
  });

  const {
    control,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  });

  const handleClose = () => {
    setOpenShare(false);
  };

  const onSubmit = async (params: any) => {
    const payload = {
      tripCode: row?.tripCode,
      tripId: row?.tripID,
      email: params?.email,
      contactNumber: params?.phone.replace('-', ''),
      source: row?.source,
      destination: row?.destination,
      startTime: row?.startTime,
      endTime: row?.endTime,
      vehicleNumber: row?.vehicleNumber,
      driverName: row?.driverName
    };
    await dispatch(shareTripsAction(payload));
    handleClose();
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      open={openShare}
      className='share-trip'
    >
      <DialogTitle id='customized-dialog-title' className='share-trip-title'>
        Share Trip
      </DialogTitle>
      <IconButton
        aria-label='close'
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme => theme.palette.grey[500]
        }}
      >
        <CloseIcon />
      </IconButton>
      <Box component='form' onSubmit={handleSubmit(onSubmit)}>
        <DialogContent>
          <Grid container sx={{ width: '100%' }}>
            <Grid item xs={12} mb={2}>
              <CustomTextField
                control={control}
                id='email'
                label='Email ID'
                placeholder='Enter the Email Id'
                name='email'
              />
            </Grid>

            <Grid item xs={12} mb={2}>
              <Controller
                name='phone'
                control={control}
                render={({ field }) => (
                  <PhoneNoTextField
                    {...field}
                    value={field.value || ''}
                    setValue={setValue}
                    style='share'
                    name='phone'
                    label='Contact Number'
                    isOptional={true}
                    error={Boolean(errors.phone)}
                    helperText={errors.phone?.message}
                  />
                )}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className='share-submit'>
          <CustomButton className={'cancel'} onClick={handleClose} category={'Cancel'} />
          <CustomButton
            className={'saveChanges'}
            loading={isLoading}
            type='submit'
            category={'Send'}
          />
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default ShareTrip;
